(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oob-mobile-buy-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    const mediaQuery = window.matchMedia('(max-width: 749px)');

    const initializeMobileBuyBar = (root = document) => {
      root.querySelectorAll('product-info').forEach((productInfo) => {
        if (productInfo.dataset.oobMobileBuyInitialized === 'true') return;

        const sentinel = productInfo.querySelector('.oob-mobile-buy-sentinel');
        const originalButton = productInfo.querySelector('.product-form__submit');
        if (!sentinel || !originalButton) return;

        productInfo.dataset.oobMobileBuyInitialized = 'true';
        document.querySelector('[data-oob-mobile-buy-for="' + productInfo.id + '"]')?.remove();

        const floatingButton = document.createElement('button');
        floatingButton.type = 'button';
        floatingButton.className = 'button button--full-width button--secondary oob-mobile-buy-bar';
        floatingButton.dataset.oobMobileBuyFor = productInfo.id;
        floatingButton.hidden = true;
        document.body.appendChild(floatingButton);

        let updateQueued = false;

        const update = () => {
          updateQueued = false;
          const currentButton = productInfo.querySelector('.product-form__submit');
          if (!currentButton) {
            floatingButton.hidden = true;
            return;
          }

          const sentinelRect = sentinel.getBoundingClientRect();
          const productRect = productInfo.getBoundingClientRect();
          const productInfoVisible = productRect.bottom > 0 && productRect.top < window.innerHeight;

          floatingButton.textContent = currentButton.textContent.trim();
          floatingButton.disabled = currentButton.disabled;
          floatingButton.hidden = !(mediaQuery.matches && sentinelRect.bottom < 0 && productInfoVisible);
        };

        const queueUpdate = () => {
          if (updateQueued) return;
          updateQueued = true;
          window.requestAnimationFrame(update);
        };

        floatingButton.addEventListener('click', () => {
          productInfo.querySelector('.product-form__submit')?.click();
        });

        window.addEventListener('scroll', queueUpdate, { passive: true });
        window.addEventListener('resize', queueUpdate, { passive: true });
        mediaQuery.addEventListener('change', queueUpdate);

        new MutationObserver(queueUpdate).observe(productInfo, {
          attributes: true,
          childList: true,
          subtree: true
        });

        update();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeMobileBuyBar(), { once: true });
    } else {
      initializeMobileBuyBar();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeMobileBuyBar(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
